import values from '../../../res/valuesPhone';
import color from '../../../res/color';

export default {
    main: {
        height: '100vh',
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        alignSelf: 'center',
        alignItems: 'center',
    },
    sideFrame: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        alignSelf: 'center',
        alignItems: 'center',
        background: color.themeColor,
        padding: '3%'
    },
    sideTitleText: {
        fontWeight: 'bold',
        fontSize: values.fontMediumLarge,
        color: color.whiteFontColor,
        marginBottom: 10,
        userSelect: "none",
    },
    meetingTimeFrame: {
        height: '35%',
        width: '90%',
        display: 'flex',
        flexDirection: 'row',
        position: 'relative',
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'space-around',
        margin: '5%',
    },
    sideTitleBorder: {
        color: color.whiteFontColor,
        borderBottom: '8px solid' + color.whiteFontColor,
        width: '30%',
        borderRadius: '5px',
    },
    sideText: {
        color: color.whiteFontColor,
        fontSize: values.fontMidium,
        userSelect: "none",
        fontWeight: 'bold',
    },
    speakTimeFrame: {
        width: '80%',
        display: 'flex',
        flexDirection: 'row',
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'center',
    },
    speakTime: {
        color: color.whiteFontColor,
        fontSize: values.fontLarge,
        fontWeight: 'bold',
        userSelect: "none",
        marginRight: '5%',
    },
    clockFrame: {
        height: '50px',
        width: '50px',
        textAlign: 'center',
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        // margin: 20,
        userSelect: "none",
    },
    bt: {
        padding: '2%',
        width: '40%',
        borderRadius: 5,
        fontSize: values.fontMediumLarge,
        color: color.blackFontColor,
        background: color.whiteBackground,
        justifyContent: 'bottom',
        alignSelf: 'center',
        textAlign: 'center',
        alignItems: 'center',
        userSelect: "none",
        cursor: 'pointer',
        position: 'relative',
        outline: 'none'
    },
    mainFrame: {
        height: '100%',
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        alignSelf: 'center',
        alignItems: 'center',
    },
    header: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        position: 'relative',
        alignSelf: 'center',
        alignItems: 'center',
        borderBottom: '3px solid' + color.themeColor,
    },
    headerContentFrame: {
        height: '100%',
        width: '50%',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'space-around',
        paddingBottom:'1%',
    },
    headerText: {
        color: color.blackFontColor,
        fontSize: values.fontMidium,
        userSelect: "none",
        position: 'relative',
        padding: 0,
        fontWeight: 'bold',
    },
    assistStateText: {
        color: color.blackFontColor,
        fontSize: values.fontSmall,
        position: 'relative',
        userSelect: 'none',
    },
    micGaugeFrame:{
        height: '20%',
        width: '60%',
        display: 'flex',
        flexDirection: 'row',
        position: 'relative',
        justifyContent: 'space-around',
        alignSelf: 'center',
        alignItems: 'center',
    },
    micGauge: {
        color: color.themeColor,
        border: '1px solid' + color.themeColor,
        height: '100%',
        width: '2%',
        borderRadius: '5px',
    },
    micButtonFrame: {
        height: '100%',
        width: '50%',
        display: 'flex',
        position: 'relative',
        justifyContent: 'space-around',
        alignSelf: 'center',
        alignItems: 'center',
    },
    micButton: {
        height: '40%',
        width: '40%',
        display: 'flex',
        position: 'relative',
        justifyContent: 'center',
        alignSelf: 'center',
        textAlign: 'center',
        alignItems: 'center',
        borderRadius: 5,
        fontSize: values.fontMidium,
        color: color.blackFontColor,
        background: color.whiteBackground,
        outline: 'none'
    },
    contentFrame: {
        height: '80%',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        position: 'relative',
        justifyContent: 'space-around',
        alignSelf: 'center',
        alignItems: 'center',
    },
    analyzingText: {
        textAlign: 'center',
        fontSize: values.fontMax,
        userSelect: "none",
    },
    tono: {
        width: '25%',
        justifyContent: 'space-around',
        alignSelf: 'center',
        userSelect: "none",
        position: 'relative',
    },
    mic: {
        width: '10%',
        justifyContent: 'space-around',
        alignSelf: 'center',
        userSelect: "none",
        position: 'relative',
    },
    elapsedTime: {
        margin: 30,
    },
    result: {
        color: color.blackFontColor,
        userSelect: "none",
    },
    clock: {
        width: values.clockSize,
        border: false,
        borderColor: color.transparent,
        baseColor: color.whiteBackground,
        centerColor: color.themeColor,
        handColors: {
            second: "#d81c7a",
            minute: color.blackFontColor,
            hour: color.blackFontColor,
        }
    }
}
